import React, { useContext } from 'react';
import RecorderDrawerContext from '../../Context';
import { ThumbnailPicker } from '@vimily/bonjoro-ui-components-v2/ThumbnailPicker';
import {
  AnimatedDiv,
  HideAnimation,
  ShowAnimation,
} from '@vimily/bonjoro-ui-components-v2/AnimatedDiv';
import useCurrentUser from '~/react-hooks/use-current-user';
import { UserEmailPreviewType } from '~/types/models';

export function ThumbnailPickerPanel() {
  const { email_preview: emailPreview } = useCurrentUser();

  const {
    hasValidVideo,
    selectedThumbnailIndex,
    setSelectedThumbnailIndex,
    interpolatedThumbnails,
    onThumbnailSelectionClick,
  } = useContext(RecorderDrawerContext);

  const onThumbnailSelect = (index: number) => {
    setSelectedThumbnailIndex(index);

    onThumbnailSelectionClick?.();
  };

  const show = hasValidVideo && emailPreview != UserEmailPreviewType.Gif;

  return (
    <AnimatedDiv
      show={show}
      className='flex flex-col gap-y-4 w-full relative'
      showAnimation={ShowAnimation.SlideInUp150}
      hideAnimation={HideAnimation.SlideOutDown150}
    >
      <div className='flex flex-row justify-between'>
        <div className='flex flex-row gap-x-4 items-center'>
          <i className='icon icon-thumbnail !v2-bg-neutral-900' />
          <span className='text-[21px] font-bold'>Thumbnail picker</span>
        </div>
      </div>
      <ThumbnailPicker
        className='w-full h-[240px]'
        imgClassName='w-full'
        thumbnails={interpolatedThumbnails}
        selected={selectedThumbnailIndex}
        onSelect={onThumbnailSelect}
      />
    </AnimatedDiv>
  );
}
